import React, { Component } from "react";
import { MSChargeDetails, PaymentType } from "@eres/mollakservicechargeapi/entities";
import Strings from "@my-dld/assets/strings";
import { toFormattedCurrency } from "@eres/core/dist/Currency";
import RadioInputField from "@eres/forms-web/RadioInputField";
import { IdExtractor, lookupConverter } from "@my-dld/utils/LookupUtil";
import FormRow from "@eres/forms-web/FormRow";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { Lookup } from "@eres/ejari-api/Entity";
import { formatAppDate } from "@my-dld/utils/Utils";

interface Props {
	details: MSChargeDetails;
	paymentTypes: PaymentType[];
	onPay: ( paymentType: PaymentType ) => void;
}

interface State {
	paymentTypes: Lookup[];
	paymentType?: number;
}

class MollakPayment extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		const types: Lookup[] = [];
		props.paymentTypes.forEach( ( pType: PaymentType ) => {
			types.push( { Id: pType.id, ...pType.title } );
		} );
		this.state = {
			paymentTypes: types,
			paymentType: types ? types[ 0 ].Id : undefined,
		};
	}

	render() {
		const { details } = this.props;
		const { InvoiceSummary, payment } = details;
		const date = InvoiceSummary.invoiceDate?.asDate();
		const invDate = date ? formatAppDate( date ) : "-";
		const dueAmount = toFormattedCurrency( ( payment.dueAmount || 0 ), 2 ) + " " + Strings.aed;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "pay-with-option",
			errorManager: defaultErrorManager,
		};
		const { paymentTypes } = this.state;
		return <div className="col-md-5 d-flex flex-column align-items-stretch">
			<div className="payment-title mt-3 mt-md-0">
				<span className="font-weight-bold">{ Strings.payment_details }</span>
			</div>
			<div className="mollak-payment">
				<div className="payment-invoice">
					<div className="invoice-date">
						<span>{ Strings.invoice_date }</span>
						<span>{ invDate }</span>
					</div>
					<div className="Invoice-ref">
						<span>{ Strings.mollak_reference_number }</span>
						<span>{ InvoiceSummary.invoiceNumber }</span>
					</div>
					<hr/>
					<div className="payable-amount">
						<span>{ Strings.total_payable }</span><br/>
						<span>{ dueAmount }</span>
					</div>
					<div className="alert alert-light-grey">
						<i className="fa fa-info-circle"/>{ Strings.mollak_payment_info }
					</div>
				</div>
				{ paymentTypes.length > 1 ? <>
					<div className="payment-title mt-3">
						<span className="font-weight-bold">{ Strings.pay_with }</span>
					</div>
					<div className="alert alert-info payment-invoice">
						<FormRow { ...filedProps }>
							<RadioInputField
								required={ true }
								id={ "paymentType" }
								toIdentifier={ IdExtractor }
								valueConverter={ lookupConverter }
								items={ paymentTypes }
								hideLabel={ true }
								inputContainerClassName={ "ps-3 pe-3" }/>
						</FormRow>
						<button
							type="button" className="btn btn_1 btn_style1 d-flex m-auto"
							data-bs-target="#serviceChargePaymentSuccess"
							onClick={ this.onPayment }>{ Strings.home_proceed_to_payment }
						</button>
					</div>
				</> : <button
					type="button" className="btn btn_1 btn_style1"
					data-bs-target="#serviceChargePaymentSuccess"
					onClick={ this.onPayment }>{ Strings.home_proceed_to_payment }
				</button> }
			</div>
		</div>;
	}

	private onPayment = () => {
		const { paymentType } = this.state;
		const { paymentTypes, onPay } = this.props;
		if ( paymentType ) {
			const selPaymentType = paymentTypes.find( type => type.id === paymentType );
			if ( selPaymentType ) {
				onPay( selPaymentType );
			}
		}
	};
}

export default MollakPayment;
